import { render, staticRenderFns } from "./LogIn.vue?vue&type=template&id=8bfd24a0&scoped=true"
import script from "./LogIn.vue?vue&type=script&lang=js"
export * from "./LogIn.vue?vue&type=script&lang=js"
import style0 from "./LogIn.vue?vue&type=style&index=0&id=8bfd24a0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bfd24a0",
  null
  
)

export default component.exports